export const clearSearchInput = () => {
  const input = document.querySelector("#autoComplete");
  input.value = "";
};
